
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/************************************  PRODUCT PERFORMANCE  ************************************/
export const ProductPerformance = () => {
  const data = [
    { product: "Lens", sales: 3200 },
    { product: "Frame", sales: 2100 },
    { product: "Solution", sales: 900 },
  ];

  const bg     = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");

  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>Product Performance</Heading>
      <Box h="220px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="product" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="sales" fill="#06b6d4" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};
